export default __webpack_public_path__ + "static/create-your-legacy-1cbde3946298d4ab8285c447a6435bcd.jpg";